import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { IntlProvider } from "./IntlProvider";
import { StateAndRouterProvider } from "./StateAndRouterProvider";
import { AuthProvider } from "./AuthContext";
import { getStore } from "./store/AppStore";
import ErrorBoundaryConfig from "./ErrorBoundaryConfig";
import AppHome from "./AppHome";
import { ErrorBoundary } from "./components/ErrorBoundary/ErrorBoundary";


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

/**
 * Responsible for rendering the App component
 */
const App = (): JSX.Element => {

  const store = getStore();

  return (
    <IntlProvider>
      <QueryClientProvider client={queryClient}>
        <StateAndRouterProvider store={store}>
          <AuthProvider>
            <ErrorBoundary {...ErrorBoundaryConfig}>
              <AppHome />
              <ReactQueryDevtools initialIsOpen={false} />
            </ErrorBoundary>
          </AuthProvider>
        </StateAndRouterProvider>
      </QueryClientProvider>
    </IntlProvider>
  );
};

export default App;
